import { useRef, useState, useEffect } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Select,
  SimpleGrid,
  Box,
  Stat,
  StatLabel,
  Divider,
  StatHelpText,
  Flex,
  Center,
  useToast,
} from "@chakra-ui/react";
// import RingLoader from "react-spinners/RingLoader";

// import Columns from "./merchant-list-columns.js";
import Comments from "./comments";
import DatePicker from "react-datepicker";
//import ReactDatePicker from 'react-datepicker';
import TextEditor from "../common/TextEditor";
import Loader from '../common/Loader'; 
import { thousandSeparator } from "../../utils/utilities";
import casesService from "../../services/cases.service";
import merchantService  from "../../services/merchant.service";
import { viewFor } from "../../utils/preferences";
import { CUIAutoComplete } from 'chakra-ui-autocomplete'

import "./case.css";

export default function CreateCaseForm(props) {
  const toast = useToast();
  const initialRef = useRef();
  const finalRef = useRef();
  const [isLoading, setisLoading] = useState(false);

  const [caseId,setCaseId] = useState(null);
  const [caseData, setCaseData] = useState({});
  const [merchantData, setMerchantData] = useState({});
  const [commentsInDB, setCommentsInDB] = useState([]);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [caseStatus, setCaseStatus] = useState("OPEN");
  const [reminderDate, setReminderDate] = useState(null);
  const [manager, setManager] = useState("");
  
  const [comment, setComment] = useState("");
  const [validationErrors, setValidationErrors] = useState({reminderDate: "", manager: "", });
  
  const preferences = JSON.parse(localStorage.getItem("preferences"));
  // Per-country case-trigger view for the merchant's country (falls back to default).
  const caseTriggerView = viewFor("caseTriggerView", merchantData && merchantData.fileCountry);
  const user = JSON.parse(localStorage.getItem("user")).user.email;


  // const [initialMount, setInitialMount] = useState(false);
  // const [createdDate, setCreatedDate] = useState(new Date());

  //Comment div height max height adjustment
  let caseDetailsElement = document.getElementsByClassName("casedetails");
  //defult height for the comment box
  let commentHeight = 480;
  if (caseDetailsElement[0] && caseDetailsElement[0].clientHeight) {
    commentHeight =
      caseDetailsElement[0].clientHeight > commentHeight
        ? caseDetailsElement[0].clientHeight
        : commentHeight;
  }

  const commentAddedAt = new Date();
  //let commentsInDB = caseData[0] ? caseData[0]["Comments"] : [];
  //let textAreaValue = caseData.length > 0 ? caseData[0]["Comments"] : [];
  const statuses = JSON.parse(localStorage.getItem("properties")).caseStatus;
  const managerList = [
    { label: "Select the Manager", value: "" },
    { label: "Jeremy", value: "Jeremy" },
    { label: "Marilyn", value: "Marilyn" },
    { label: "Yeoh", value: "Yeoh" },
  ];

  const initalSetup = async ()=>{
    setisLoading(true);
    if(props.merchant["case"].length !== 0){ //setting the data if the case already exist
      setCaseId(props.merchant["case"][0]._id);
      let data = await casesService.fetchByCaseId(props.merchant["case"][0]._id);
      if (data.error) {
        toast({
          title: data.error,
          position: "top",
          status: "error",
          isClosable: true,
        });
        setisLoading(false);
        props.onClose();
        return;
      }
      if(data.warning){
        toast({
          title: data.warning,
          position: "top",
          status: "warning",
          duration: 10000,
          isClosable: true,
        });
        props.onClose();
        return;
      }
      if(!data.merchantObjID){
        setisLoading(false);
        toast({
          title: 'Transaction details not found',
          position: "top",
          status: "warning",
          duration: 10000,
          isClosable: true,
        });
        props.onClose();
        return;
      }
      setCaseData(data);
      setMerchantData(data.merchantObjID);
      setCommentsInDB(data.Comments);
      setSelectedColumns(data.selectedColumns);
      setCaseStatus(data.status);
      if(data.reminderDate) 
        setReminderDate(new Date(data.reminderDate));
      if(data.manager)
        setManager(data.manager);
      setisLoading(false);  
      return;
    }else{ //setting the data for new case.
      let data = await merchantService.fetchById(props.merchant["_id"]);
      if (data.error) {
        toast({
          title: data.error,
          position: "top",
          status: "error",
          isClosable: true,
        });
        setisLoading(false);
        props.onClose();
        return;
      }
      if(data.warning){
        toast({
          title: data.warning,
          position: "top",
          status: "warning",
          duration: 10000,
          isClosable: true,
        });
        setisLoading(false);
        props.onClose();
        return;
      }
      setMerchantData(data.result);
      if(data.result.case.length > 0){
        setCaseId(data.result.case[0]._id);
        setCaseData(data.result.case[0]);
        setCommentsInDB(data.result.case[0].Comments);
        setSelectedColumns(data.result.case[0].selectedColumns);
        setCaseStatus(data.result.case[0].status);
        if(data.result.case[0].reminderDate) 
          setReminderDate(new Date(data.result.case[0].reminderDate));
        if(data.result.case[0].manager)
          setManager(data.result.case[0].manager);  
      }
      setisLoading(false);
      return;
    }
  }

  useEffect(() => {
    initalSetup();
    //Disabling the ES-lint dependency warning, This hook is to implement componentdidmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const selectedColumnsSetRulesFromMerchant = (selectedColumns =[])=>{
    for(let i=0;i<selectedColumns.length;i++){
      let _merchantData = {...merchantData[selectedColumns[i]['value']]};
      if(_merchantData){
        selectedColumns[i]['triggerValue'] = _merchantData.value;
        delete _merchantData.value;
        selectedColumns[i] = {...selectedColumns[i], ..._merchantData} 
      }
    }
    return selectedColumns;
  }
  //setdataToBeSavedInDB(caseSpecificData);
  const saveCase = async () => {
    if (manager === "") {
      let error = {};
      if (manager === "") error["manager"] = "Manager required...!";
      // if (!reminderDate) error["reminderDate"] = "Reminder date required...!";
      setValidationErrors({ ...validationErrors, ...error });
      return;
    }
    let url = `cases/save`;
    let caseSpecificData = {};
    if(caseId){
      url = `${url}/${caseId}`
      caseSpecificData['selectedColumns'] = selectedColumnsSetRulesFromMerchant([...selectedColumns]) ;
      caseSpecificData['status'] = caseStatus ;
      caseSpecificData['manager'] = manager;
      caseSpecificData['reminderDate'] = reminderDate ? reminderDate : undefined ;
      caseSpecificData['comment'] = comment ? { comment: comment, date: commentAddedAt, author: user } : undefined ;
    }else{
      caseSpecificData = {
          merchantObjID: merchantData._id,
          "Merchant Legal Name": merchantData["Merchant Legal Name"].value,
          "Merchant": merchantData["Merchant"].value,
          "Actual Volume": merchantData["Actual Volume"].value,
          "Target Volume": merchantData["Target Volume"].value,
          "Record Average": merchantData["Record Average"].value,
          "Current Average": merchantData["Current Average"].value,
          // "Record Max": merchantData["Record Max"].value,
          // "Current Max": merchantData["Current Max"].value,
          "Refund % Spike": merchantData["Refund % Spike"].value,
          "Refund Vol Spike": merchantData["Refund Vol Spike"].value,
          "Refund Volume by PAN": merchantData["Refund Volume by PAN"].value,
          "Refund Volume by PAN %": merchantData["Refund Volume by PAN %"].value,
          "Refund Frequency by PAN (Daily)": merchantData["Refund Frequency by PAN (Daily)"].value,
          "Refund Frequency by PAN (Monthly)": merchantData["Refund Frequency by PAN (Monthly)"].value,
          "Refund Daily Frequency vs 90 Days Max": merchantData["Refund Daily Frequency vs 90 Days Max"].value,
          "Daily Count Deviation": merchantData["Daily Count Deviation"].value,
          "Comments": comment ? [{ comment: comment, date: commentAddedAt, author: user }] : [] ,
          "selectedColumns": selectedColumnsSetRulesFromMerchant([...selectedColumns]),
          "status": caseStatus,
          "manager": manager,
          "reminderDate": reminderDate ? reminderDate : undefined,
          "createdDate": new Date(),
          "fileDate": new Date(merchantData["fileDate"]),
          "fileCountry": merchantData["fileCountry"],
          "fileName": merchantData["fileName"],
          "uploadedDate": new Date(merchantData["createdDate"])
      };
    }
    if(comment){
      setCommentsInDB([...commentsInDB, { comment: comment, date: commentAddedAt, author: user }]);
    }
    setisLoading(true);
    let data = await casesService.save(url, caseSpecificData)//.then((data) => {
      setisLoading(false);
      if (data.error) {
        toast({
          title: data.error,
          position: "top",
          status: "error",
          isClosable: true,
        });
        if (caseData) {
          setSelectedColumns([...caseData["selectedColumns"]]);
          setCaseStatus(caseData["status"]);
          setCommentsInDB([...caseData["Comments"]]);
        } else {
          setSelectedColumns([]);
          setCaseStatus("OPEN");
          setCommentsInDB([]);
        }
        return;
      }
      if (data.warning) {
        toast({
          title: data.warning,
          position: "top",
          status: "warning",
          duration: 10000,
          isClosable: true,
        });
        setisLoading(false);
        return;
      }
      toast({
        title: !caseId ? `Case created...!`: `Case updated...!`,
        position: "top",
        status: "success",
        isClosable: true,
      });
      if(!caseId){
        setCaseId(data._id)
      }
      if(props.hasOwnProperty('updateChange'))
        props.updateChange(data);
      setComment("");
      
      return ;  
    } 
      //return data;
   // });

    


    // console.log('caseId ',caseId);
    // let caseSpecificData = {
    //   merchantObjID: merchantData._id,
    //   "Merchant Legal Name": merchantData["Merchant Legal Name"].value,
    //   Merchant: merchantData["Merchant"].value,
    //   "Actual Volume": merchantData["Actual Volume"].value,
    //   "Target Volume": merchantData["Target Volume"].value,
    //   "Record Average": merchantData["Record Average"].value,
    //   "Current Average": merchantData["Current Average"].value,
    //   "Record Max": merchantData["Record Max"].value,
    //   "Current Max": merchantData["Current Max"].value,
    //   Comments: commentsInDB,
    //   selectedColumns: selectedColumns,
    //   status: caseStatus,
    //   manager: manager,
    //   reminderDate: reminderDate ? reminderDate : undefined,
    //   createdDate: createdDate ? createdDate : undefined,
    //   fileDate: new Date(merchantData["fileDate"]),
    //   fileName: merchantData["fileName"],
    //   uploadedDate: new Date(merchantData["createdDate"]),
    // };
    // if (comment) {
    //   let newComments = {
    //     comment: comment,
    //     date: commentAddedAt,
    //     author: user,
    //   };
    //   caseSpecificData["Comments"] = [
    //     ...caseSpecificData["Comments"],
    //     newComments,
    //   ];
    //   setCommentsInDB([...commentsInDB, newComments]);

    //   // if (
    //   //   caseData &&
    //   //   caseData[0] &&
    //   //   caseData[0]["Comments"] &&
    //   //   Array.isArray(caseData[0]["Comments"])
    //   // ) {
    //   //   textAreaValue.push({
    //   //     comment: comment,
    //   //     date: commentAddedAt,
    //   //     author: user,
    //   //   });
    //   // } else {
    //   //   textAreaValue.push({
    //   //     comment: comment,
    //   //     date: commentAddedAt,
    //   //     author: user,
    //   //   });
    //   // }
    // }
    // for (let col in selectedColumns) {
    //   if (merchantData[col.value])
    //     caseSpecificData[col.label] = merchantData[col.value].value;
    // }
    // // selectedColumns.map((col, i) => {
    // //   if (merchantData[col.value])
    // //     caseSpecificData[col.label] = merchantData[col.value].value;
    // // });

    // let param = "";
    // if (
    //   merchantData["case"] &&
    //   merchantData["case"][0] &&
    //   merchantData["case"][0]["_id"]
    // ) {
    //   param = merchantData["case"][0]["_id"];
    //   url = `cases/save/${param}`;
    // }
    // // const requestOptions = {
    // //   method: "POST",
    // //   body: JSON.stringify(caseSpecificData),
    // //   headers: {
    // //     Accept: "application/json",
    // //     "Content-Type": "application/json",
    // //   },
    // // };
    // setisLoading(true);
    // casesService.save(url, caseSpecificData).then((data) => {
    //   setisLoading(false);
    //   if (data.error) {
    //     toast({
    //       title: data.error,
    //       position: "top",
    //       status: "error",
    //       isClosable: true,
    //     });
    //     if (caseData[0]) {
    //       setSelectedColumns([...caseData[0]["selectedColumns"]]);
    //       setCaseStatus(caseData[0]["status"]);
    //       setCommentsInDB([...caseData[0]["Comments"]]);
    //     } else {
    //       setSelectedColumns([]);
    //       setCaseStatus("OPEN");
    //       //setCommentsInDB([]);
    //     }
    //     return;
    //   }
    //   if (data.warning) {
    //     toast({
    //       title: data.warning,
    //       position: "top",
    //       status: "warning",
    //       duration: 10000,
    //       isClosable: true,
    //     });
    //     setisLoading(false);
    //     return;
    //   }
    //   toast({
    //     title: `The data is saved suceessfully!`,
    //     position: "top",
    //     status: "success",
    //     isClosable: true,
    //   });
    //   props.updateChange(data);
    //   setComment("");
    //   return data;
    // });
  //};
  // const editorState = EditorState.createEmpty();
  // const onEditorStateChange = (editorState) => {
  //   console.log(editorState);
  // };
  const setCommentFromEditor = (value) => {
    setComment(value);
  };

  return (
    <>
      <Modal
        initialFocusRef={initialRef}
        finalFocusRef={finalRef}
        isOpen={props.isOpen}
        onClose={props.onClose}
        size="xl"
      >
        <ModalOverlay />
        <ModalContent maxW="70rem">
          <ModalHeader>
            {caseId ? `Case-${caseId}` : "New case"}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <Flex>
              {/* <Box className={isLoading ? "lodder-display" : "lodder-disable"}>
                <RingLoader color="#5e5e72" loading={isLoading} size={50} />
              </Box> */}
              <Loader isLoading={isLoading} />
              {/* <LoadingStyle.OverlayBox>
                <RingLoader
                  color="#D0021B"
                  loading={isLoading}
                  css={override}
                  size={50}
                />
              </LoadingStyle.OverlayBox> */}
              <Box mr={10} flex="2" className={"casedetails"}>
                <SimpleGrid columns={4}>
                  <Box>
                    <Stat>
                      <StatLabel>Legal Name</StatLabel>
                      <StatHelpText>
                        {merchantData["Merchant Legal Name"] && merchantData["Merchant Legal Name"].value}
                      </StatHelpText>
                    </Stat>
                  </Box>
                  <Box>
                    <Stat>
                      <StatLabel>Merchant ID</StatLabel>
                      <StatHelpText>
                        { merchantData["Merchant"] && merchantData["Merchant"].value}
                      </StatHelpText>
                    </Stat>
                  </Box>
                  <Box>
                    <Stat>
                      {/* const [validationErrors,setValidationErrors] = useState({"reminderDate":"","manager":""}) */}
                      <StatLabel>Manager</StatLabel>
                    </Stat>
                    <Select
                      borderColor={validationErrors.manager ? "red" : "#E2E8F0"}
                      size="xs"
                      onChange={(e) => {
                        setValidationErrors({
                          ...validationErrors,
                          manager: "",
                        });
                        setManager(e.target.value);
                      }}
                      value={manager}
                    >
                      {managerList.map((s, i) => {
                        return (
                          <option key={i} value={s.value}>
                            {s.label}
                          </option>
                        );
                      })}
                    </Select>
                    {/* <Text color="red" fontSize="xs">{validationErrors.manager}</Text> */}
                  </Box>
                  <Box pl={2}>
                    <Stat>
                      <StatLabel>Status</StatLabel>
                    </Stat>
                    <Select
                      size="xs"
                      onChange={(e) => setCaseStatus(e.target.value)}
                      value={caseStatus}
                    >
                      {statuses.map((s, i) => {
                        return (
                          <option key={i} value={s.value}>
                            {s.label}
                          </option>
                        );
                      })}
                    </Select>
                  </Box>
                </SimpleGrid>
                <Box borderWidth="1px" borderRadius="lg" p={4}>
                  <SimpleGrid columns={1}>
                  <CUIAutoComplete
                    label=""
                    placeholder="Trigger Type"
                    items={preferences.caseTriggerList}
                    selectedItems={selectedColumns}
                    onSelectedItemsChange={(changes) => setSelectedColumns([...new Map(changes.selectedItems.map((item) => [item.value, item])).values()])}
                    tagStyleProps={{
                      justifyContent:'space-between',
                      width: '200px',
                      marginLeft: '8px',
                      marginBottom: '0px',
                      background:'#c0daf314',
                      border:'1px solid #c0daf3'
                    }}   
                  />
                    {/* <Columns
                      onSelect={setSelectedColumns}
                      selectedColumns={selectedColumns}
                    />*/}
                  </SimpleGrid> 

                  {selectedColumns.length > 0 && (
                    <SimpleGrid columns={3}>
                      {selectedColumns.map((col, i) => {
                        return (
                          <Box key={i}>
                            <Stat>
                              <StatLabel>{col.label}</StatLabel>
                              <StatHelpText>
                              {merchantData[col.value]
                                ? !isNaN(merchantData[col.value].value) 
                                  ? 
                                    merchantData[col.value].datatype === 'percentage' 
                                    ?
                                      merchantData[col.value].isExactValueRequired       
                                      ?
                                        `${(merchantData[col.value].value * 100).toFixed(2)}%`
                                      :
                                        `${Math.round(merchantData[col.value].value * 100)}%` 
                                    :
                                      merchantData[col.value].datatype === 'currency'
                                      ?   
                                        `${merchantData[col.value].symbol}${thousandSeparator(merchantData[col.value].value)}`
                                      :
                                        thousandSeparator(merchantData[col.value].value)
                                  : 
                                    merchantData[col.value].value
                                : 
                                  ""
                              }
                              </StatHelpText>
                            </Stat>
                          </Box>
                        );
                      })}
                    </SimpleGrid>
                  )}
                </Box>
                <Divider />

                <SimpleGrid columns={4} spacingX="10px" spacingY="20px" mt={10}>
                  {caseTriggerView.map((item) => (
                    <Box key={item.value}>
                      <Stat>
                        <StatLabel>{item.label}</StatLabel>
                        <StatHelpText>
                          {merchantData[item.value]
                            ? !isNaN(merchantData[item.value].value) 
                              ? 
                                merchantData[item.value].datatype === 'percentage' 
                                ?
                                  merchantData[item.value].isExactValueRequired       
                                  ?
                                    `${(merchantData[item.value].value * 100).toFixed(2)}%`
                                  :
                                    `${Math.round(merchantData[item.value].value * 100)}%` 
                                :
                                  merchantData[item.value].datatype === 'currency'
                                  ?   
                                    `${merchantData[item.value].symbol}${thousandSeparator(merchantData[item.value].value)}`
                                  :
                                    thousandSeparator(merchantData[item.value].value)
                              : 
                                merchantData[item.value].value
                            : 
                              ""}
                        </StatHelpText>
                      </Stat>
                    </Box>
                  ))}
                  <Box>
                    <Stat>
                      <StatLabel>Reminder Day</StatLabel>
                    </Stat>
                    <Box
                      w={"130px"}
                      // className={
                      //   validationErrors.reminderDate ? "validationError" : "customDatePickerWidth"
                      // }
                    >
                      <DatePicker
                        wrapperClassName="datePicker"
                        dateFormat="dd-MMM-yyyy"
                        minDate={new Date()}
                        selected={reminderDate}
                        onChange={(date) => {
                          // setValidationErrors({
                          //   ...validationErrors,
                          //   reminderDate: "",
                          // });
                          setReminderDate(date);
                        }}
                      />
                      {/* <Text color="red" fontSize="xs">{validationErrors.reminderDate}</Text> */}
                    </Box>
                  </Box>
                </SimpleGrid>
                <SimpleGrid columns={1} spacingX="10px" spacingY="20px" mt={10}>
                  <Box>
                    <Stat>
                      <StatLabel>Risk Assesment</StatLabel>
                      {/* <Textarea
                        value={comment}
                        placeholder="Add Comments"
                        onChange={(event) =>
                          setComment(event.currentTarget.value)
                        }
                      /> */}
                    </Stat>
                    <Box borderWidth="1px" borderRadius="lg" p={1}>
                      <TextEditor handleChange={setCommentFromEditor} />
                    </Box>
                  </Box>
                </SimpleGrid>
                <Box></Box>
              </Box>
              <Box
                borderWidth="1px"
                borderRadius="lg"
                p={4}
                flex="1"
                overflowY="scroll"
                minH="485px"
                maxH={commentHeight}
              >
                <Comments comments={commentsInDB} />
                {Array.isArray(commentsInDB) && !commentsInDB.length && (
                  <Stat>
                    {/* <StatHelpText> */}
                    <Center>No Comments</Center>
                    {/* </StatHelpText> */}
                  </Stat>
                )}
              </Box>
            </Flex>
          </ModalBody>

          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={saveCase}>
              Save
            </Button>
            <Button onClick={props.onClose}>Cancel</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}


// import React from 'react'

// function CreateCaseForm() {
//   return (
//     <div>
      
//     </div>
//   )
// }

// export default CreateCaseForm
